import React from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { UploadFileData } from '../../state/reducer';
import { addUploadingFile, setFilePendingConfirmation } from '../../state/actions';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  fileData: UploadFileData[];
}

export const FilePendingConfirmationModal = ({ fileData }: Props) => {
  const dispatch = useDispatch();
  const [closeModal, setCloseModal] = React.useState(
    fileData.reduce((acc, _, index) => ({ ...acc, [index]: true }), {}),
  );

  if (fileData.length === 0) {
    return null;
  }

  return (
    <>
      {fileData.map((data, index) => (
        <FilePendingConfirmationModalContent
          key={index}
          file={data.file}
          isOpen={closeModal[index]}
          onClose={() => {
            // Last item is shown first.
            // So, first item (index 0) is the last one to be closed.
            if (index === 0) {
              dispatch(setFilePendingConfirmation(null));
            }
            return setCloseModal(state => ({ ...state, [index]: false }));
          }}
        />
      ))}
    </>
  );
};

interface ContentProps {
  file: File;
  isOpen: boolean;
  onClose: () => void;
}

const FilePendingConfirmationModalContent = ({ file, isOpen, onClose }: ContentProps) => {
  const dispatch = useDispatch();

  const { path } = useRouteParams();

  return (
    <Modal
      contentLabel="Login Details"
      size="medium"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      aria={{ labelledby: 'duplicate-file-name' }}
    >
      <Box>
        <ModalHeader variant="warning" id="duplicate-file-name">
          Duplicate File Name
        </ModalHeader>
        <ModalCloseButton onClick={onClose} />

        <ModalBody>
          The file &quot;{file.name}&quot; already exists. Do you want to replace it?
        </ModalBody>

        <ModalFooter>
          <Button variant="subtleInactive" onClick={onClose}>
            Cancel
          </Button>

          <Button
            type="submit"
            ml="12"
            isLoading={false}
            onClick={() => {
              dispatch(addUploadingFile({ fileId: uuidv4(), file, path }));
              onClose();
            }}
          >
            Replace
          </Button>
        </ModalFooter>
      </Box>
    </Modal>
  );
};
